import { useState, useEffect } from "react";
import "./landing.css";
import Logo from "./assets/logo.png";
import MegaMenu from "./MegaMenu";
import MegaServiceMenu from "./MegaServiceMenu";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [visible, setVisible] = useState(true);
  const [showIndustries, setShowIndustries] = useState(false);
  const [showServices, setShowServices] = useState(false);
  let lastScrollY = 0;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) setVisible(false);
      else setVisible(true);
      lastScrollY = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`floating-navbar ${visible ? "show" : "hide"}`}
        style={{ zIndex: "500" }}
      >
        {/* Logo */}
        <div className="logo">
          <Link to="/">
          <img
            src={Logo}
            alt="MyLogo"
            style={{
              width: "140px",
              height: "20px",
              objectFit: "contain",
            }}
          /></Link>
        </div>

        {/* Nav Links */}
        <ul className="nav-links">
        <Link to="/ai" className="gradient-border-link">
        AI Agents
       </Link>
          <li><Link to="/about">About</Link></li>

          {/* Services */}
          <li
            className="services-link"
            onMouseEnter={() => {
              setShowServices(true);
              setShowIndustries(false);
            }}
          >
            <Link to="/">Services</Link>
          </li>

          {/* Industries */}
          <li
            className="industries-link"
            onMouseEnter={() => {
              setShowIndustries(true);
              setShowServices(false);
            }}
          >
            <Link to="/">Industries</Link>
          </li>
<li>
  <a
    href="https://drive.google.com/file/d/1GDK9L6aePlarQKkCiWYW0b2QaDuAPpB_/view"
    target="_blank"
    rel="noopener noreferrer"
  >
    Portfolio
  </a>
</li>

          <li><Link to="/contact" className="button-85 text-light">Contact</Link></li>
        </ul>
      </nav>

      {/* Mega Menus stay open while hovering inside */}
      <MegaMenu
        show={showIndustries}
        onClose={() => setShowIndustries(false)}
      />
      <MegaServiceMenu
        show={showServices}
        onClose={() => setShowServices(false)}
      />
    </>
  );
};

export default Navbar;
